import { createFileRoute, Outlet } from "@tanstack/react-router";
import { OnboardingOverlay } from "@/app/onboarding-first-win/components/onboarding-overlay";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/onboarding"
)({
  component: OnboardingLayout,
});

function OnboardingLayout() {
  return (
    <OnboardingOverlay>
      <Outlet />
    </OnboardingOverlay>
  );
}
